'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { ImageWithFallback as Image } from '@/components/common/image-with-fallback'
import { useTranslations } from 'next-intl'

export const MainContent = () => {
  const t = useTranslations('page_avery_dennision_factory')

  return (
    <div>
      <h1 className='mb-3 font-criteria text-2xl font-semibold text-neutral-900 md:mb-6 md:text-4xl 2xl:text-[44px]'>
        {t('title')}
      </h1>
      <div className='text-base text-neutral-900 md:text-lg'>
        <p>{t('intro_1')}</p>
        <p>{t('intro_2')}</p>
        <div className='mt-4'>
          <Image
            src={ImageHelper.getImageUrl('/image/August2025/mceclip23_18.jpg')}
            alt='Avery Dennison Office Interior'
            width={1200}
            height={400}
            className='w-full rounded-2xl object-contain'
          />
        </div>
        <h2 className='mt-5 text-xl font-medium leading-normal text-neutral-800 md:mt-10 md:text-[28px]'>
          {t('partnership_title')}
        </h2>

        <div className='my-4 md:my-10'>
          <div className='grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5'>
            <div className='rounded-2xl bg-neutral-50 p-4'>
              <div className='mb-3 flex-shrink-0'>
                <Image
                  src={ImageHelper.getImageUrl('/image/August2025/mceclip2_85.png')}
                  alt='Technology icon'
                  width={1200}
                  height={400}
                  className='h-12 w-12 2xl:h-20 2xl:w-20'
                />
              </div>
              <div>
                <h3 className='text-lg font-medium text-neutral-800 md:text-xl 2xl:text-2xl'>
                  {t('features.technology_title')}
                </h3>
                <p className='mt-2 text-sm text-neutral-800 md:text-base'>
                  {t('features.technology_desc')}
                </p>
              </div>
            </div>
            <div className='rounded-2xl bg-neutral-50 p-4'>
              <div className='mb-3 flex-shrink-0'>
                <Image
                  src={ImageHelper.getImageUrl('/image/August2025/mceclip0_31.png')}
                  alt='Materials icon'
                  width={1200}
                  height={400}
                  className='h-12 w-12 2xl:h-20 2xl:w-20'
                />
              </div>
              <div>
                <h3 className='text-lg font-medium text-neutral-800 md:text-xl 2xl:text-2xl'>
                  {t('features.materials_title')}
                </h3>
                <p className='mt-2 text-sm text-neutral-800 md:text-base'>
                  {t('features.materials_desc')}
                </p>
              </div>
            </div>
            <div className='relative rounded-2xl bg-neutral-50 p-4'>
              <div className='mb-3 flex-shrink-0'>
                <Image
                  src={ImageHelper.getImageUrl('/image/August2025/mceclip1_30.png')}
                  alt='International standards icon'
                  width={1200}
                  height={400}
                  className='h-12 w-12 2xl:h-20 2xl:w-20'
                />
              </div>
              <div>
                <h3 className='text-lg font-medium text-neutral-800 md:text-xl 2xl:text-2xl'>
                  {t('features.standards_title')}
                </h3>
                <p className='mt-2 text-sm text-neutral-800 md:text-base'>
                  {t('features.standards_desc')}
                </p>
              </div>
              <div className='absolute bottom-0 right-0 z-0 h-full'>
                <Image
                  src={ImageHelper.getImageUrl('/image/August2025/mceclip3_5.png')}
                  alt='Avery Dennison Factory'
                  width={100}
                  height={50}
                  className='object-cover opacity-10'
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className='relative mt-10 overflow-hidden rounded-2xl p-8 text-white md:px-6 md:py-10'
          style={{
            background: 'linear-gradient(91.05deg, #1A1A1A 0%, #525252 100%)',
          }}
        >
          <div className='absolute bottom-0 left-0 top-0 z-0'>
            <Image
              src={ImageHelper.getImageUrl('/image/August2025/mceclip4_98.png')}
              alt='background pattern'
              width={250}
              height={150}
              className='h-full w-auto object-cover'
            />
          </div>
          <div className='relative z-10 text-center'>
            <p className='text-base md:text-lg'>{t('quote')}</p>
            <h3 className='mt-4 font-criteria text-2xl font-semibold uppercase md:mt-6 md:text-4xl'>
              {t('quote_highlight')}
            </h3>
          </div>
        </div>
      </div>
    </div>
  )
}
